export default {
  components: {
    fullScreenMessage: {
      title: 'dt.common.components.fullScreenMessage.title',
      text: 'dt.common.components.fullScreenMessage.text',
    },
    contestCardButtons: 'dt.common.components.contestCardButtons',
    contestCard: 'dt.common.components.contestCard',
    contestCardHeader: 'dt.common.components.contestCardHeader',
    manageInvites: 'dt.common.components.manageInvites',
    appShellHeader: {
      userPill: 'dt.common.components.appShellHeader.userPill',
      userMenu: {
        container: 'dt.common.components.appShellHeader.userMenu.container',
        depositButton: 'dt.common.components.appShellHeader.userMenu.depositButton',
        withdrawButton: 'dt.common.components.appShellHeader.userMenu.withdrawButton',
      },

      userDetailContainer: 'dt.common.components.appShellHeader.userDetailContainer',
      handle: 'dt.common.components.appShellHeader.handle',
      balance: 'dt.common.components.appShellHeader.balance',
      mobileMenuButton: 'dt.common.components.appShellHeader.mobileMenuButton',
      userMenuButton: 'dt.common.components.appShellHeader.userMenuButton',
      menuItem: 'dt.common.components.appShellHeader.menuItem',
      depositButton: 'dt.common.components.appShellHeader.depositButton',
      notificationsCounter: 'dt.common.components.appShellHeader.notificationsCounter',
      promotionsButton: 'dt.common.components.appShellHeader.promotionsButton',
      notificationsButton: 'dt.common.components.appShellHeader.notificationsButton',
      notificationsListItem: 'dt.common.components.appShellHeader.notificationsListItem',
      homeButton: 'dt.common.components.appShellHeader.homeButton',
      headerUserInfo: {
        handle: 'dt.common.components.appShellHeader.headerUserInfo.handle',
      },
    },
    appShellSubheader: {
      subHeaderLink: 'dt.common.components.appShellSubheader.subHeaderLink',
    },
    modal: {
      confirmModal: {
        confirmButton: 'dt.common.components.modal.confirmModal.confirmButton',
        cancelButton: 'dt.common.components.modal.confirmModal.cancelButton',
      },
    },
    banner: {
      generic: 'dt.common.components.banner.generic',
      verificationBanner: 'dt.common.components.banner.verificationBanner',
      RAFbanner: 'dt.common.components.banner.RAFbanner',
    },
    appDownloadPrompt: {
      continueUsingWeb: 'dt.common.components.appDownloadPrompt.continueUsingWeb',
    },
    welcomeModal: {
      container: 'dt.common.components.welcomeModal.container',
      actionButton: 'dt.common.components.welcomeModal.actionButton',
    },
    RAFdrawer: {
      copyReferralLinkButton: 'dt.common.components.RAFdrawer.copyReferralLinkButton',
      copyCodeIcon: 'dt.common.components.RAFdrawer.copyCodeIcon',
    },
  },
};
